import Vue from 'vue';
import Router from 'vue-router';
import Nav from '../components/common/nav.js';
import { Message } from 'element-ui'

Vue.use(Router);



const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        // {
        //     path: '/',
        //     component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
        //     meta: { title: '自述文件' },
        //     children: Nav.routerData
        // },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '首页' },
            children: [
                { path: '/indexpage', component: () => import('@/components/page/indexpage.vue'), meta: { title: '首页' } },
            ]
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '营销管理' },
            children: Nav.routeSale
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '账款管理' },
            children: Nav.routeAccounts
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '系统设置' },
            children: Nav.routeSystem
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '资料与设定' },
            children: Nav.routeSet
        },

      
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' },
            
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

export default router